// extracted by mini-css-extract-plugin
module.exports = {"container":"ArtistDetails_container__n_zM9","subtitle":"ArtistDetails_subtitle__JkPBL"};